import { IModel } from 'core-ts-types';
import { ICampusSectionGroup, IUnscheduledSectionsByCampusVisibility } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';

export class UnscheduledSectionsVisibilityModel implements IModel {
  private _sections_display_limit_by_campus: IUnscheduledSectionsByCampusVisibility[] = [];
  private defaultDisplayLimit: number;

  constructor(private ngTermScheduleFlags: any) {}

  initialize() {
    this.clear();
    this.defaultDisplayLimit = this.ngTermScheduleFlags.getNumberOfSeatsRequestsPerCourse();
  }

  clear(): UnscheduledSectionsVisibilityModel {
    this._sections_display_limit_by_campus = [];
    return this;
  }

  write(source: IUnscheduledSectionsByCampusVisibility[]): UnscheduledSectionsVisibilityModel {
    this._sections_display_limit_by_campus = _4.merge(this._sections_display_limit_by_campus, source);
    return this;
  }

  viewMoreTimes(campus: ICampusSectionGroup) {
    this.defaultDisplayLimit = this.ngTermScheduleFlags.getNumberOfSeatsRequestsPerCourse();
    const currentCampusDisplay = this.get(campus.name);
    const updatedCampusDisplay = {
      campusName: campus.name,
      displayQuantity: currentCampusDisplay.displayQuantity + this.defaultDisplayLimit
    };
    this.update(updatedCampusDisplay);
  }

  read(): IUnscheduledSectionsByCampusVisibility[] {
    return this._sections_display_limit_by_campus;
  }

  get(campusName: string) {
    const campusLimitObj = _4.find(this._sections_display_limit_by_campus, ['campusName', campusName]);
    let limitThreshold = 25;
    if (this.ngTermScheduleFlags.getNumberOfSeatsRequestsPerCourse() !== 0) {
      limitThreshold = this.ngTermScheduleFlags.getNumberOfSeatsRequestsPerCourse();
    }
    if (_4.isUndefined(campusLimitObj)) {
      return { campusName, displayQuantity: limitThreshold };
    } else {
      return campusLimitObj;
    }
  }

  update(source: IUnscheduledSectionsByCampusVisibility) {
    this._sections_display_limit_by_campus = _4.reject(
      this._sections_display_limit_by_campus,
      (limitByCampus) => limitByCampus.campusName === source.campusName
    );
    this._sections_display_limit_by_campus.push(source);
    return this;
  }
}

angular
  .module('capability-ng-scheduler')
  .service('ngUnscheduledSectionsVisibilityModel', UnscheduledSectionsVisibilityModel);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/unscheduled_sections/models/unscheduled_sections_visibility_model.ts